import {
  AuthApi,
  BillingApi,
  ConfigApi,
  InstallationsApi,
  ReposApi,
} from 'generated-sources';

export const API_MAP = {
  AuthApi,
  BillingApi,
  ConfigApi,
  InstallationsApi,
  ReposApi,
} as const;

export type ApiMap = typeof API_MAP;
export type ApiMapKey = keyof ApiMap;
